// frontend/src/components/DashboardHeader.js (NEW FILE)
import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../App";
import "./DashboardHeader.css"; // Create this CSS file

function DashboardHeader() {
  const { user, handleLogout } = useContext(AuthContext);
  const navigate = useNavigate();

  const onLogoutClick = () => {
    handleLogout();
    navigate("/"); // Redirect to home after logout
  };

  const handleUpgradeClick = () => {
    navigate("/pricing");
  };

  // This should not render if user is null, but check just in case
  if (!user) return null;

  return (
    <header className="dashboard-header">
      <div className="container">
        <nav>
          <Link to="/" className="logo">
            Grandmaster AI
          </Link>{" "}
          {/* Link back home */}
          <div className="nav-links">
            {/* Add Dashboard specific links if needed */}
            <Link to="/dashboard">Overview</Link>
            {/* <Link to="/dashboard/settings">Settings</Link> */}
          </div>
          <div className="auth-section">
            <span className="user-info">
              {user.lichess_username} ({user.plan})
            </span>
            {user.plan === "free" && (
              <button onClick={handleUpgradeClick} className="upgrade-button">
                Upgrade
              </button>
            )}
            <button onClick={onLogoutClick} className="logout-button">
              Logout
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
}

export default DashboardHeader;
